import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { theme } from '../../../domain/theme';

const baseStyles = {
  description: css`
    width: 100%;
    display: block;
    ${theme.font.family('regularWeb')};
    font-weight: ${theme.font.weight('l')};
    font-size: ${theme.font.size('l')};
    line-height: 1.5;
    letter-spacing: 5px;
    color: #e6e6e6;
    margin: ${theme.spacing.parse('$xs2 0 $l 0')};
    text-align: center;
    text-transform: uppercase;
  `
};

export const ContentPackageDescription = ({ description, styles }) => (
  <p css={[baseStyles.description, styles]}>{description}</p>
);

ContentPackageDescription.defaultProps = {
  styles: undefined
};

ContentPackageDescription.propTypes = {
  description: PropTypes.string.isRequired,
  styles: PropTypes.objectOf(PropTypes.any)
};
